package com.eladfinish.bible.contest.screens.search.api

import com.eladfinish.bible.contest.network.DefaultApiResult
import com.eladfinish.bible.contest.network.GithubURL
import com.eladfinish.bible.contest.network.apiResultUTF16
import com.eladfinish.bible.contest.network.apiResultUTF8
import io.ktor.client.HttpClient
import io.ktor.client.request.forms.submitForm
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.HttpHeaders
import io.ktor.http.Parameters

interface SearchGithubApi {
    suspend fun getRootsDicta(
        downloadType: String,
        replaceShemos: Boolean,
        showNikudAndTeamim: String,
        sort: String,
        query: String,
    ): String

    suspend fun getRootResults(root: String): DefaultApiResult<RootResult>
    suspend fun getNumberResults(number: Int): DefaultApiResult<NumberResult>

    /** [day] == null: the whole month. */
    suspend fun getDateResults(month: Int, day: Int?): DefaultApiResult<DateResult>
}

class SearchGithubApiImpl(
    private val client: HttpClient,
) : SearchGithubApi {

    override suspend fun getRootsDicta(
        downloadType: String,
        replaceShemos: Boolean,
        showNikudAndTeamim: String,
        sort: String,
        query: String,
    ): String {
        return client.submitForm(
            url = "https://tanach-search-3-0.loadbalancer.dicta.org.il/download",
            formParameters = Parameters.build {
                append("downloadType", downloadType)
                append("replaceShemos", replaceShemos.toString())
                append("showNikudAndTeamim", showNikudAndTeamim)
                append("sort", sort)
                append("query", query)
            },
            encodeInQuery = false // Ensures the parameters are sent in the body of the request
        ) {
            header(HttpHeaders.ContentType, ContentType.Application.FormUrlEncoded)
        }.bodyAsText()
    }

    override suspend fun getRootResults(root: String): DefaultApiResult<RootResult> = apiResultUTF16 {
        client.get(GithubURL.rootUrl(letter = root.first().toString(), root = root))
    }

    override suspend fun getNumberResults(number: Int): DefaultApiResult<NumberResult> = apiResultUTF16 {
        client.get(GithubURL.numberUrl(number = number))
    }

    // UTF-8, not apiResultUTF16: the dates data is plain ASCII JSON
    override suspend fun getDateResults(month: Int, day: Int?): DefaultApiResult<DateResult> = apiResultUTF8 {
        client.get(
            if (day == null) GithubURL.dateMonthUrl(month = month) else GithubURL.dateUrl(month = month, day = day),
        )
    }

}
